import styled from 'styled-components';
import { GetDealersExperience } from '~/utils/dealerUtils';
import hyundai from '../../stories/assets/hyundai/background.jpg';
import genesis from '../../stories/assets/genesis/background.jpg';
import unifi from '../../stories/assets/Splash.jpg';

const dealersExperiences = {
  hyundai,
  unifi,
  genesis,
};

const backgroundUrl = dealersExperiences[GetDealersExperience() as keyof typeof dealersExperiences] || dealersExperiences.unifi;

export const StyledBackground = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: url('${backgroundUrl}');
  z-index: -1;
  background-size: cover;
`;
